export const categoryArticles: Record<string, Array<{
  id: number;
  title: string;
  thumbnail: string;
  duration: string;
  views: number;
  date: string;
  author: string;
  description: string;
  tags: string[];
}>> = {
  "dating-tips": [
    {
      id: 101,
      title: "第一次约会必知的10个小技巧",
      thumbnail: "https://readdy.ai/api/search-image?query=A%20romantic%20coffee%20shop%20date%20scene%20with%20a%20couple%20sitting%20at%20a%20wooden%20table%20near%20a%20large%20window%2C%20soft%20warm%20lighting%2C%20two%20coffee%20cups%2C%20comfortable%20atmosphere%2C%20clean%20minimalist%20background%2C%20editorial%20photography%20style&width=800&height=450&seq=cat-dating-01&orientation=landscape",
      duration: "12:38",
      views: 125800,
      date: "2026-08-05",
      author: "情感导师小艾",
      description: "第一次约会总是让人既期待又紧张，本期视频准备了10个实用技巧。",
      tags: ["约会技巧", "恋爱入门", "社交指南"],
    },
    {
      id: 102,
      title: "相亲时应该问的15个关键问题",
      thumbnail: "https://readdy.ai/api/search-image?query=A%20blind%20date%20scene%20at%20a%20modern%20restaurant%2C%20two%20people%20having%20a%20pleasant%20conversation%2C%20elegant%20table%20setting%2C%20warm%20ambient%20lighting%2C%20genuine%20expressions&width=800&height=450&seq=cat-dating-02&orientation=landscape",
      duration: "14:20",
      views: 56200,
      date: "2026-08-06",
      author: "情感导师小艾",
      description: "相亲时如何高效了解对方？这15个问题帮你快速判断是否合适。",
      tags: ["相亲", "恋爱技巧", "沟通"],
    },
    {
      id: 103,
      title: "如何优雅地表达自己的好感",
      thumbnail: "https://readdy.ai/api/search-image?query=A%20shy%20person%20writing%20a%20love%20letter%20at%20a%20wooden%20desk%2C%20warm%20candle%20light%2C%20romantic%20atmosphere%2C%20vintage%20stationery%2C%20soft%20focus%2C%20clean%20minimalist%20background&width=800&height=450&seq=cat-dating-03&orientation=landscape",
      duration: "10:15",
      views: 89200,
      date: "2026-08-04",
      author: "情感导师小艾",
      description: "喜欢一个人却不知道如何开口？学会这些表达方式，让对方感受到你的真诚。",
      tags: ["表白技巧", "恋爱心理", "社交"],
    },
    {
      id: 104,
      title: "恋爱初期的3个常见误区",
      thumbnail: "https://readdy.ai/api/search-image?query=A%20young%20couple%20having%20a%20misunderstanding%20in%20a%20park%2C%20sitting%20on%20opposite%20ends%20of%20a%20bench%2C%20autumn%20scenery%2C%20emotional%20distance%20theme%2C%20soft%20natural%20light&width=800&height=450&seq=cat-dating-04&orientation=landscape",
      duration: "13:40",
      views: 67800,
      date: "2026-08-02",
      author: "情感导师小艾",
      description: "刚恋爱时最容易犯的错误，你中了几个？提前了解，避开感情雷区。",
      tags: ["恋爱误区", "情感建议", "新手必看"],
    },
    {
      id: 105,
      title: "约会穿搭指南：给对方留下好印象",
      thumbnail: "https://readdy.ai/api/search-image?query=A%20stylish%20person%20trying%20on%20different%20outfits%20in%20front%20of%20a%20mirror%2C%20modern%20walk-in%20closet%2C%20fashionable%20casual%20wear%2C%20date%20preparation%2C%20bright%20natural%20lighting%2C%20clean%20aesthetic&width=800&height=450&seq=cat-dating-05&orientation=landscape",
      duration: "09:55",
      views: 45600,
      date: "2026-07-30",
      author: "形象顾问Lisa",
      description: "第一次约会穿什么？不同场合的穿搭建议，让你自信赴约。",
      tags: ["约会穿搭", "形象管理", "第一印象"],
    },
    {
      id: 106,
      title: "线上聊天的艺术：如何让话题不断",
      thumbnail: "https://readdy.ai/api/search-image?query=A%20person%20smiling%20while%20texting%20on%20a%20smartphone%2C%20cozy%20cafe%20setting%2C%20chat%20bubbles%20floating%2C%20digital%20communication%20concept%2C%20warm%20lighting%2C%20modern%20minimalist%20style&width=800&height=450&seq=cat-dating-06&orientation=landscape",
      duration: "11:25",
      views: 73400,
      date: "2026-07-28",
      author: "情感导师小艾",
      description: "聊天总是冷场？学会这些技巧，让你的线上对话永远不尴尬。",
      tags: ["线上聊天", "社交技巧", "沟通"],
    },
  ],
  "love-stories": [
    {
      id: 201,
      title: "异地恋如何维持感情的秘诀",
      thumbnail: "https://readdy.ai/api/search-image?query=A%20couple%20video%20calling%20on%20a%20laptop%20screen%2C%20warm%20cozy%20bedroom%20setting%20with%20fairy%20lights%2C%20distance%20love%20concept%2C%20soft%20evening%20light%2C%20emotional%20connection%20theme&width=800&height=450&seq=cat-story-01&orientation=landscape",
      duration: "18:25",
      views: 98300,
      date: "2026-08-03",
      author: "故事收集者小鹿",
      description: "异地恋真的那么难吗？三对成功情侣的独家秘诀。",
      tags: ["异地恋", "情感维系", "真实故事"],
    },
    {
      id: 202,
      title: "那些年我们追过的校园爱情",
      thumbnail: "https://readdy.ai/api/search-image?query=A%20beautiful%20university%20campus%20with%20cherry%20blossom%20trees%2C%20young%20couple%20sitting%20on%20a%20bench%20reading%20books%2C%20nostalgic%20youthful%20love%20theme%2C%20soft%20spring%20sunlight&width=800&height=450&seq=cat-story-02&orientation=landscape",
      duration: "20:15",
      views: 78900,
      date: "2026-08-05",
      author: "故事收集者小鹿",
      description: "从校服到婚纱，那些纯真的校园爱情故事，你还记得吗？",
      tags: ["校园爱情", "青春回忆", "真实故事"],
    },
    {
      id: 203,
      title: "90岁夫妻的爱情保鲜秘诀",
      thumbnail: "https://readdy.ai/api/search-image?query=An%20elderly%20couple%20holding%20hands%20on%20a%20park%20bench%20during%20golden%20hour%2C%20deep%20wrinkles%20and%20warm%20smiles%2C%20lifetime%20love%20theme%2C%20beautiful%20sunset%20light%2C%20heartwarming%20atmosphere&width=800&height=450&seq=cat-story-03&orientation=landscape",
      duration: "16:40",
      views: 156200,
      date: "2026-08-01",
      author: "故事收集者小鹿",
      description: "携手走过70年的老夫妻，他们的爱情故事让无数人泪目。",
      tags: ["金婚", "爱情保鲜", "感人故事"],
    },
    {
      id: 204,
      title: "跨国恋的真实经历：跨越万里的爱情",
      thumbnail: "https://readdy.ai/api/search-image?query=A%20couple%20from%20different%20cultures%20embracing%20at%20an%20airport%2C%20reunion%20scene%2C%20international%20love%20concept%2C%20emotional%20moment%2C%20soft%20natural%20light%2C%20cinematic%20photography&width=800&height=450&seq=cat-story-04&orientation=landscape",
      duration: "22:30",
      views: 67800,
      date: "2026-07-29",
      author: "故事收集者小鹿",
      description: "文化差异、时差、语言障碍……跨国恋的真实挑战与甜蜜。",
      tags: ["跨国恋", "文化差异", "真实经历"],
    },
    {
      id: 205,
      title: "离婚后重新找到真爱的故事",
      thumbnail: "https://readdy.ai/api/search-image?query=A%20person%20smiling%20confidently%20walking%20on%20a%20sunny%20beach%2C%20new%20beginning%20concept%2C%20fresh%20start%20after%20heartbreak%2C%20hopeful%20and%20bright%20atmosphere%2C%20clean%20minimalist%20style&width=800&height=450&seq=cat-story-05&orientation=landscape",
      duration: "19:15",
      views: 89200,
      date: "2026-07-25",
      author: "故事收集者小鹿",
      description: "结束一段婚姻不代表幸福终结，听听这些勇敢者的重生故事。",
      tags: ["离婚", "重生", "二婚幸福"],
    },
  ],
  marriage: [
    {
      id: 301,
      title: "婚姻七年之痒的破解之道",
      thumbnail: "https://readdy.ai/api/search-image?query=A%20happy%20middle-aged%20couple%20walking%20hand%20in%20hand%20in%20a%20beautiful%20autumn%20park%2C%20golden%20leaves%20falling%2C%20genuine%20smiles%2C%20long-term%20relationship%20theme&width=800&height=450&seq=cat-marr-01&orientation=landscape",
      duration: "22:10",
      views: 87600,
      date: "2026-08-01",
      author: "婚姻咨询师李老师",
      description: "结婚七年，激情褪去后如何保持婚姻温度？专业咨询师深度解析。",
      tags: ["婚姻", "七年之痒", "夫妻关系"],
    },
    {
      id: 302,
      title: "夫妻吵架后如何快速和好",
      thumbnail: "https://readdy.ai/api/search-image?query=A%20couple%20making%20up%20after%20an%20argument%2C%20holding%20hands%20across%20a%20wooden%20table%2C%20warm%20home%20interior%2C%20candle%20light%2C%20reconciliation%20and%20forgiveness%20theme&width=800&height=450&seq=cat-marr-02&orientation=landscape",
      duration: "11:30",
      views: 67800,
      date: "2026-08-04",
      author: "婚姻咨询师李老师",
      description: "吵架不可怕，可怕的是不会和好。学会这5招，让每次争吵都成为感情升温的契机。",
      tags: ["夫妻吵架", "和好技巧", "沟通"],
    },
    {
      id: 303,
      title: "婆媳关系的处理智慧",
      thumbnail: "https://readdy.ai/api/search-image?query=A%20mother-in-law%20and%20daughter-in-law%20cooking%20together%20in%20a%20bright%20modern%20kitchen%2C%20harmonious%20family%20relationship%2C%20warm%20smiles%2C%20cooperation%2C%20soft%20natural%20daylight&width=800&height=450&seq=cat-marr-03&orientation=landscape",
      duration: "17:50",
      views: 112300,
      date: "2026-08-02",
      author: "婚姻咨询师李老师",
      description: "婆媳关系是婚姻中的一大难题，智慧处理让家庭更和睦。",
      tags: ["婆媳关系", "家庭和谐", "婚姻经营"],
    },
    {
      id: 304,
      title: "有了孩子后如何保持夫妻感情",
      thumbnail: "https://readdy.ai/api/search-image?query=A%20young%20couple%20with%20a%20baby%2C%20both%20parents%20sharing%20a%20tender%20moment%20while%20the%20baby%20sleeps%2C%20family%20love%20theme%2C%20soft%20warm%20lighting%2C%20cozy%20home%20interior&width=800&height=450&seq=cat-marr-04&orientation=landscape",
      duration: "15:20",
      views: 94500,
      date: "2026-07-31",
      author: "婚姻咨询师李老师",
      description: "孩子是爱情的结晶，但也可能成为感情的考验，如何做到两不误？",
      tags: ["育儿", "夫妻感情", "家庭"],
    },
  ],
  psychology: [
    {
      id: 401,
      title: "从心理学看为什么你总是吸引错的人",
      thumbnail: "https://readdy.ai/api/search-image?query=A%20thoughtful%20person%20looking%20at%20their%20reflection%20in%20a%20large%20modern%20mirror%2C%20self%20discovery%20concept%2C%20minimalist%20bright%20interior%20with%20plants&width=800&height=450&seq=cat-psych-01&orientation=landscape",
      duration: "15:42",
      views: 112400,
      date: "2026-07-30",
      author: "心理学博士王教授",
      description: "从依恋理论出发，帮你认识自己的情感模式，打破恶性循环。",
      tags: ["心理学", "依恋理论", "自我认知"],
    },
    {
      id: 402,
      title: "MBTI性格类型与恋爱匹配度解析",
      thumbnail: "https://readdy.ai/api/search-image?query=Colorful%20personality%20type%20concept%20illustration%20with%20abstract%20geometric%20shapes%2C%20personality%20types%20visualization%2C%20modern%20flat%20design%2C%20vibrant%20yet%20soft%20colors&width=800&height=450&seq=cat-psych-02&orientation=landscape",
      duration: "19:50",
      views: 94200,
      date: "2026-08-03",
      author: "心理学博士王教授",
      description: "你的MBTI类型最适合和哪种类型恋爱？科学解读性格匹配度。",
      tags: ["MBTI", "性格测试", "恋爱匹配"],
    },
    {
      id: 403,
      title: "分手后的心理修复指南",
      thumbnail: "https://readdy.ai/api/search-image?query=A%20person%20sitting%20peacefully%20by%20a%20window%20with%20sunlight%20streaming%20in%2C%20journaling%20in%20a%20notebook%2C%20healing%20and%20self-care%20theme%2C%20calm%20atmosphere%2C%20clean%20minimalist%20interior&width=800&height=450&seq=cat-psych-03&orientation=landscape",
      duration: "14:30",
      views: 128900,
      date: "2026-08-06",
      author: "心理学博士王教授",
      description: "失恋的痛苦如何科学排解？心理学方法帮你走出情伤，重新出发。",
      tags: ["分手", "心理修复", "自我成长"],
    },
    {
      id: 404,
      title: "爱情中的「沉没成本」陷阱",
      thumbnail: "https://readdy.ai/api/search-image?query=An%20abstract%20concept%20of%20sunk%20cost%20fallacy%2C%20a%20person%20at%20a%20crossroads%2C%20decision%20making%20theme%2C%20minimalist%20design%20with%20soft%20gradients%2C%20clean%20aesthetic&width=800&height=450&seq=cat-psych-04&orientation=landscape",
      duration: "12:15",
      views: 76200,
      date: "2026-07-28",
      author: "心理学博士王教授",
      description: "为什么明明不快乐却离不开？了解沉没成本如何影响你的感情决策。",
      tags: ["沉没成本", "决策心理", "恋爱误区"],
    },
  ],
  relationships: [
    {
      id: 501,
      title: "男女思维差异到底有多大",
      thumbnail: "https://readdy.ai/api/search-image?query=Two%20silhouettes%20facing%20each%20other%20with%20puzzle%20pieces%20floating%20between%20them%2C%20gender%20communication%20concept%2C%20modern%20minimalist%20design%2C%20soft%20gradient%20background&width=800&height=450&seq=cat-rel-01&orientation=landscape",
      duration: "16:05",
      views: 135600,
      date: "2026-08-02",
      author: "两性关系专家陈老师",
      description: "男人和女人的思维方式真的存在天壤之别吗？科学解读两性差异。",
      tags: ["男女差异", "沟通", "两性关系"],
    },
    {
      id: 502,
      title: "现代年轻人的爱情观变迁",
      thumbnail: "https://readdy.ai/api/search-image?query=A%20diverse%20group%20of%20young%20people%20having%20a%20lively%20discussion%20in%20a%20modern%20coworking%20space%2C%20contemporary%20love%20and%20relationship%20theme%2C%20bright%20natural%20light&width=800&height=450&seq=cat-rel-02&orientation=landscape",
      duration: "18:30",
      views: 87200,
      date: "2026-07-31",
      author: "两性关系专家陈老师",
      description: "不婚主义、开放式关系、丁克…当代年轻人的爱情观正在发生什么变化？",
      tags: ["爱情观", "年轻人", "社会变迁"],
    },
    {
      id: 503,
      title: "如何在感情中保持独立人格",
      thumbnail: "https://readdy.ai/api/search-image?query=A%20person%20meditating%20peacefully%20in%20a%20minimalist%20room%20with%20plants%2C%20self-love%20and%20independence%20concept%2C%20calm%20and%20balanced%20atmosphere%2C%20soft%20morning%20light&width=800&height=450&seq=cat-rel-03&orientation=landscape",
      duration: "13:45",
      views: 65400,
      date: "2026-07-27",
      author: "两性关系专家陈老师",
      description: "爱一个人不等于失去自我，学会在亲密关系中保持独立人格。",
      tags: ["独立人格", "自我成长", "健康关系"],
    },
  ],
  "hot-shows": [
    {
      id: 601,
      title: "《心动的信号》第六季精彩回顾",
      thumbnail: "https://readdy.ai/api/search-image?query=A%20romantic%20reality%20TV%20show%20set%20with%20beautiful%20villa%20and%20garden%2C%20young%20singles%20mingling%2C%20dating%20show%20concept%2C%20warm%20sunset%20lighting&width=800&height=450&seq=cat-show-01&orientation=landscape",
      duration: "25:30",
      views: 189000,
      date: "2026-08-01",
      author: "综艺观察员小美",
      description: "第六季最甜CP大盘点！回顾那些让人心动的名场面。",
      tags: ["心动的信号", "恋爱综艺", "CP"],
    },
    {
      id: 602,
      title: "《再见爱人》最让人泪目的瞬间",
      thumbnail: "https://readdy.ai/api/search-image?query=An%20emotional%20reality%20show%20moment%2C%20a%20couple%20having%20a%20deep%20conversation%20in%20a%20beautiful%20natural%20setting%2C%20relationship%20healing%20theme%2C%20soft%20dramatic%20lighting&width=800&height=450&seq=cat-show-02&orientation=landscape",
      duration: "28:15",
      views: 213500,
      date: "2026-08-04",
      author: "综艺观察员小美",
      description: "那些让人破防的瞬间，每对夫妻的故事都值得我们深思。",
      tags: ["再见爱人", "婚姻综艺", "催泪"],
    },
    {
      id: 603,
      title: "《半熟恋人》中年人的爱情也浪漫",
      thumbnail: "https://readdy.ai/api/search-image?query=Mature%20singles%20enjoying%20a%20cooking%20date%20in%20a%20beautiful%20kitchen%2C%20midlife%20romance%20reality%20show%20concept%2C%20warm%20and%20elegant%20atmosphere%2C%20sophisticated%20style&width=800&height=450&seq=cat-show-03&orientation=landscape",
      duration: "22:40",
      views: 167800,
      date: "2026-08-06",
      author: "综艺观察员小美",
      description: "谁说浪漫是年轻人的专利？半熟恋人的爱情故事同样动人。",
      tags: ["半熟恋人", "中年爱情", "恋爱综艺"],
    },
    {
      id: 604,
      title: "《我们恋爱吧》海岛之旅名场面合集",
      thumbnail: "https://readdy.ai/api/search-image?query=A%20beautiful%20tropical%20island%20with%20young%20couples%20enjoying%20beach%20activities%2C%20reality%20dating%20show%20setting%2C%20sunny%20paradise%20theme%2C%20vibrant%20colors&width=800&height=450&seq=cat-show-04&orientation=landscape",
      duration: "20:50",
      views: 145200,
      date: "2026-08-05",
      author: "综艺观察员小美",
      description: "海岛、阳光、恋爱，最浪漫的综艺场景都在这里了。",
      tags: ["我们恋爱吧", "海岛", "名场面"],
    },
  ],
};

export const articleDetails: Record<number, {
  id: number;
  title: string;
  category: string;
  categoryName: string;
  author: string;
  authorAvatar: string;
  date: string;
  views: number;
  duration: string;
  thumbnail: string;
  tags: string[];
  summary: string;
  content: Array<{ type: "paragraph" | "heading" | "list"; text?: string; items?: string[] }>;
  relatedArticles: number[];
}> = {
  101: {
    id: 101,
    title: "第一次约会必知的10个小技巧",
    category: "dating-tips",
    categoryName: "恋爱技巧",
    author: "情感导师小艾",
    authorAvatar: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20warm%20smiling%20Chinese%20woman%20in%20her%20early%2030s%2C%20clean%20white%20background%2C%20professional%20yet%20friendly%20look&width=100&height=100&seq=author-xiaoai&orientation=squarish",
    date: "2026-08-05",
    views: 125800,
    duration: "12:38",
    thumbnail: "https://readdy.ai/api/search-image?query=A%20romantic%20coffee%20shop%20date%20scene%20with%20a%20couple%20sitting%20at%20a%20wooden%20table%20near%20a%20large%20window%2C%20soft%20warm%20lighting%2C%20two%20coffee%20cups%2C%20comfortable%20atmosphere&width=800&height=450&seq=article-detail-101&orientation=landscape",
    tags: ["约会技巧", "恋爱入门", "社交指南"],
    summary: "第一次约会总是让人既期待又紧张。本期视频为你准备了10个实用小技巧，从见面问候到告别细节，帮你轻松应对约会中的各种场景。",
    content: [
      { type: "heading", text: "前言" },
      { type: "paragraph", text: "第一次约会，是两个人从相识走向相知的重要一步。无论你们是通过朋友介绍、社交软件还是相亲认识，第一次约会都至关重要——它决定了你们是否还会有第二次见面的机会。然而，很多人在第一次约会时因为紧张而表现失常，错过了进一步发展的大好机会。今天，我们就来聊聊第一次约会时需要注意的10个关键技巧。" },
      { type: "heading", text: "1. 选择合适的约会地点" },
      { type: "paragraph", text: "第一次约会的地点选择非常重要。建议选择一个安静、舒适、便于交流的场所，比如一家有格调的咖啡馆或一个环境优美的公园。避免选择过于嘈杂的餐厅或电影院——你需要的是一个能够顺畅交流的环境。同时，选择公共场所也是对双方安全的保障。" },
      { type: "heading", text: "2. 着装得体但不过度" },
      { type: "paragraph", text: "第一印象只需7秒钟就能形成，而衣着是其中非常重要的部分。不需要穿得过于正式或华丽，但一定要干净整洁、搭配得体。选择让自己感到舒适的服装，这样你才能展现最自然的状态。记住：最好的着装是让对方记住你这个人，而不是你的衣服。" },
      { type: "heading", text: "3. 准时到达" },
      { type: "paragraph", text: "守时是对他人最基本的尊重。建议提前10-15分钟到达约会地点，这样你可以有时间整理情绪、选择好位置。如果确实需要迟到，一定要提前告知对方并真诚道歉。第一次约会就迟到，会给人留下不靠谱的印象。" },
      { type: "heading", text: "4. 真诚的微笑是最好的开场" },
      { type: "paragraph", text: "见面时的一个真诚微笑，可以瞬间拉近两个人的距离。不需要刻意准备华丽的问候语，简单自然地说一句「你好，很高兴见到你」就足够了。眼神交流也很重要——看着对方的眼睛说话，展现你的专注和诚意。" },
      { type: "heading", text: "5. 学会倾听" },
      { type: "paragraph", text: "很多人第一次约会时太着急表现自己，不停地说话，却忽略了倾听对方。一个好的对话应该是双向的——给对方充足的表达空间，认真听TA说什么，然后给予恰当的回应。倾听不仅能让对方感到被重视，也能帮你更好地了解这个人。" },
      { type: "heading", text: "6. 聊天的内容要有层次" },
      { type: "paragraph", text: "第一次约会的聊天内容可以从轻松的话题开始，比如兴趣爱好、旅行经历、美食偏好等。随着交流的深入，可以适当聊一些价值观层面的内容，比如对生活的态度、对未来的规划等。但要避免过于私密或沉重的话题，比如前任、收入、家庭矛盾等。" },
      { type: "heading", text: "7. 手机静音，全心投入" },
      { type: "paragraph", text: "没有什么比约会时对方频繁看手机更让人扫兴的了。把手机调成静音，放在口袋或包里，把全部注意力放在眼前这个人身上。这个小小的举动传达出的信息是：此时此刻，你比任何事情都重要。" },
      { type: "heading", text: "8. 适度的肢体语言" },
      { type: "paragraph", text: "肢体语言能传递很多言语无法表达的信息。保持开放的坐姿，身体微微前倾表示你在认真倾听。适时的点头和微笑是最安全的积极反馈。但注意不要过度——第一次约会时过分的身体接触可能会让对方感到不适。" },
      { type: "heading", text: "9. 结账时的礼仪" },
      { type: "paragraph", text: "关于谁来买单这个问题，没有绝对的标准答案。一般来说，主动邀约的一方可以主动买单。如果对方坚持AA制，也不必勉强。重要的是这个过程中展现出的态度——大方、自然、不斤斤计较。" },
      { type: "heading", text: "10. 约会后的跟进" },
      { type: "paragraph", text: "约会结束后的跟进同样重要。如果你对这次见面感觉不错，可以在当天晚上发一条简短的消息，比如「今天很开心，谢谢你」或者提到约会中聊过的某个有趣话题。这样的跟进既表达了你的好感，又不会显得过于急切。" },
      { type: "heading", text: "总结" },
      { type: "paragraph", text: "第一次约会最重要的不是完美表现，而是展现真实的自己。以上10个技巧的核心目的，是帮你创造一个舒适的环境，让两个人能够自然、真诚地交流。记住，最好的关系建立在真实的基础上——做最好的自己，而不是假装成别人。祝你的第一次约会顺利！" },
    ],
    relatedArticles: [102, 103, 105],
  },
};